module.exports = __webpack_public_path__ + "static/media/posted.158f7bbb.svg";